import { transport } from 'config/transport';

export function callApiUpdateKhanDong(congDoanId, nunId, id, body) {
    return transport.put(`/congdoan/${congDoanId}/khandong/${nunId}/${id}`, body);
}
